import { Button, Stack, StackProps } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTranslation } from "react-i18next";
import { useRegistrationJourney } from "journey";
import { PropsWithChildren } from "react";

export const RegistrationJourneyButtons = ({
  children,
  sx,
  ...props
}: PropsWithChildren<StackProps>) => {
  const { t } = useTranslation();
  const { stepIndex, hasNextStep, cancel, setStep } = useRegistrationJourney();

  return (
    <Stack direction={{ sm: "row" }} sx={{ gap: 2, py: 2, ...sx }} {...props}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIosIcon />}
        onClick={() => setStep({ stepIndex: stepIndex - 1 })}
      >
        {t("buttons.prevStep")}
      </Button>
      <Button variant="text" onClick={cancel}>
        {t("buttons.cancel")}
      </Button>
      {hasNextStep && (
        <Button
          variant="contained"
          type="submit"
          endIcon={<ArrowForwardIosIcon />}
          sx={{ ml: { sm: "auto" } }}
        >
          {t("buttons.next")}
        </Button>
      )}
      {children}
    </Stack>
  );
};
